import React, { useState } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import { HPSaaS1  ,
   IndImage1,
  IndImage2,
  IndImage3,
  IndImage4,
  IndImage5,
  IndImage6,} from "../constant";
import CustomGlowButton from "./GlowingButton";

const revealAnimation = keyframes`
  from {
    transform: scale(0);
    border-radius: 50%;
    transform-origin: bottom left;
  }
  to {
    transform: scale(1);
    border-radius: 0%;
    transform-origin: bottom left;
  }
`;

const closeRevealAnimation = keyframes`
  from {
    transform: scale(1);
    border-radius: 0%;
    transform-origin: bottom left;
  }
  to {
    transform: scale(0);
    border-radius: 50%;
    transform-origin: bottom left;
  }
`;

const MainContainer = styled(Box)(({ theme }) => ({
  background: "#000",
  display: "flex",
  flexDirection: "column",
  padding: "60px 24px",
  position: "relative",
  overflow: "hidden",

  "&::after": {
    content: '""',
    position: "absolute",
    width: "95%",
    height: "80%",
    left: "65%",
    top: "10%",
    bottom: "10%",
    transform: "translateX(-100%), translateY(-50%)",
    background:
      "radial-gradient(circle, rgba(99, 102, 241, 0.5) 0%, rgba(99, 102, 241, 0) 70%)",
    filter: "blur(80px)",
    zIndex: 0,
  },
}));

const ContentContainer = styled(Box)({
  width: "100%",
  maxWidth: "1200px",
  margin: "auto",
  position: "relative",
  zIndex: 1,
});

const CardContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  overflow: "hidden",
  position: "relative",
  width: "100%",
  cursor: "pointer",
  transition: "transform 0.3s ease-in-out",
  margin: "auto",
  "&:hover": {
    transform: "scale(1.02)",
  },
}));

const RevealAnimation = styled(Box)(({ active }) => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%",
  height: active ? "100%" : "0%",
  background: "rgba(23, 58, 167, 1)",
  transition: "height 0.5s ease-in-out",
  zIndex: 2,
  overflow: "hidden",
  animation: active ? `${revealAnimation} 0.5s ease-in-out` : `${closeRevealAnimation} 0.5s ease-in-out`,
}));

const CardContent = styled(Box)(({ active, theme }) => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  padding: theme.spacing(2),
  opacity: active ? 1 : 0,
  transition: "opacity 0.4s ease-in-out",
  zIndex: 3,
  color: "white",
  textAlign: "center",
  maxWidth: "100%",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center", 
  justifyContent: "center", 
  height: "100%", 
}));


const ImageWrapper = styled(Box)({
  width: "100%",
  height: "100%",
  position: "relative",
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  "& img": {
    width: "100%",
    maxHeight: "205px",
    objectFit: "cover", // Ensures the image covers the wrapper without distortion
  },
});

const serviceCards = [
  {
    id: 1,
    title: "Oil & Energy",
    description:
      "Improving safety, compliance, and operational visibility across complex energy operations",
    image: IndImage1 ,
  },
  {
    id: 2,
    title: "Power & Renewable",
    description:
      "Strengthening reliability, sustainability performance, and operational oversight for modern energy enterprises",
    image: IndImage2,
  },
  {
    id: 3,
    title: "Mining & Metal ",
    description:
      "Enhancing workforce safety, governance, and efficiency across mining and metals operations",
    image: IndImage3,
  },
  {
    id: 4,
    title: "Engineering & Construction",
    description:
      "Streamlining project oversight, contractor coordination, and operational accountability across industrial projects",
    image: IndImage4,
  },
  {
    id: 5,
    title: "Health & Pharma",
    description:
      "Supporting compliance, operational quality, and process consistency across healthcare and pharmaceutical environments",
    image: IndImage5,
  },
  {
    id: 6,
    title: "Food Processing",
    description:
      "Improving production oversight, workplace safety, and compliance across food manufacturing operations",
    image: IndImage6,
  },
];

const SaaSExcellence = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeCards, setActiveCards] = useState({});

  const handleCardInteraction = (id) => {
    setActiveCards((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <MainContainer>
      <ContentContainer>
        <Grid container spacing={3}>
          {/* Left Content */}
          <Grid item xs={12} md={5} lg={5}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent= "space-evenly"
              height="100%"
              pr={{ xs: 0, md: 10 }}
              mt={{ xs: 0, md: 4 }}
            >
              <Typography
                variant="h2"
                sx={{
                  color: "#6366F1",
                  backgroundColor: "background: linear-gradient(262.41deg, #1DA1F2 -8.32%, #6843EC 93.3%)",
                  fontSize: { xs: "28px", md: "40px", lg: "42px" },
                  fontWeight: 700,
                  mb: 5,
                  lineHeight: 1.2,
                }}
              >
                "Built for the Industries That Power the World"
              </Typography>
              <Typography
                sx={{
                  color: "#8C8CC2",
                  fontSize: { xs: "14px", sm: "16px" },
                  lineHeight: 1.8,
                  mb: 4,
                }}
              >
               Delivering operational excellence, governance, sustainability performance, and enterprise visibility across complex industrial environments
              </Typography>
              {/* <Typography
                sx={{
                  color: "#8C8CC2",
                  fontSize: { xs: "14px", sm: "16px" },
                  lineHeight: 1.8,
                  mb: 4,
                }}
              >
              We provide a collaborative development ecosystem that enables you to innovate and transform
              </Typography>              */}
            </Box>
          </Grid>

          {/* Right Content - Cards */}
          <Grid item xs={12} md={7} lg={7}>
            <Grid container spacing={2}>
              {serviceCards.map((card) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={4}
                  key={card.id}
                 
                >
                  <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
                    <CardContainer
                      onClick={() => handleCardInteraction(card.id)}
                      onMouseEnter={() => !isMobile && handleCardInteraction(card.id)}
                      onMouseLeave={() => !isMobile && handleCardInteraction(card.id)}
                    >
                      <ImageWrapper><img src={card.image} /></ImageWrapper>

                      {/* Reveal animation */}
                      <RevealAnimation active={activeCards[card.id]} />

                      {/* Card content */}
                      <CardContent active={activeCards[card.id]} sx={{
                          padding: {
                            xs: theme.spacing(1.5),
                            sm: theme.spacing(2),
                          }}}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 600,
                            mb: 1,
                            fontSize: { xs: "15px", sm: "16px", md: "18px" },
                          }}
                        >
                          {card.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "14px" },
                            opacity: 0.8,
                            display: "-webkit-box",
                            WebkitLineClamp: { xs: 3, sm: 4, md: 5 },
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            wordBreak: "break-word",
                          }}
                        >
                          {card.description}
                        </Typography>
                      </CardContent>
                    </CardContainer>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </ContentContainer>
    </MainContainer>
  );
};

export default SaaSExcellence;
